function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => changeItem(data_line,0));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-searchbox','open-sort','open-filter');
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-searchbox','open-sort','open-filter');
      });
    });
    qtybtns();
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
      	document.querySelector('.header-cart').classList.add('orangecart');
        document.querySelector('.drawer-header h4').classList.add('orangecart');
      }else{
      	document.querySelector('.header-cart').classList.remove('orangecart');
        document.querySelector('.drawer-header h4').classList.remove('orangecart');
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function changeItem(data_line,qty){
  const data = {'line': data_line ,'quantity':qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
function qtybtns(){
  var cdquanity_box = document.querySelectorAll('.cd-quanitity');
  if(cdquanity_box){
    cdquanity_box.forEach(function(quantitywrap){
      var cdquantity_minus = quantitywrap.querySelector(".cd_minus");
      var cdquantity_add = quantitywrap.querySelector(".cd_plus");
      var cdquantity = quantitywrap.querySelector(".cd_qty");
      const minimum = 1;
      if(cdquantity_minus){
        cdquantity_minus.addEventListener("click", function(){
          if (cdquantity.value <= minimum) {
            cdquantity_minus.disabled = true;
            return;
          } else {
            cdquantity_minus.disabled = false;
          }
          cdquantity.value--;
          var data_line = this.closest('.item-row').dataset.line;
          var input_qty = cdquantity.value;
          changeItem(data_line,input_qty);         
        });
      }
      if(cdquantity_add){
        cdquantity_add.addEventListener("click", function() {
          if (cdquantity.value > minimum) {
            cdquantity.disabled = false;
          }
          cdquantity.value++; 
          var data_line = this.closest('.item-row').dataset.line;
          var input_qty = cdquantity.value;
          changeItem(data_line,input_qty);
        });
      }
    });
  }
}